import { post } from "@services/apiService.js";
export default {

  uploadQRcodeWechat(data, onUploadProgress, options) {
    return post(`/v4/design-manager/v1/social/uploadfile`, data, { 'Content-Type': 'multipart/form-data' }, { onUploadProgress, ...options })
      .then(response => {
        return response.data || {};
      })
      .catch(error => {
        return error.response
      });
  }
}